import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '电影', path: '/category/dianying' },
    { label: '电视剧', path: '/category/dianshiju' },
    { label: '综艺', path: '/category/zongyi' },
    { label: '动漫', path: '/category/dongman' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系方式', path: '/about#contact' },
    { label: '用户口碑', path: '/about#testimonials' },
    { label: '发展历程', path: '/about#milestones' },
  ],
  合作伙伴: [
    { label: '西瓜视频免费', path: '/' },
    { label: '芒果视频', path: '/' },
    { label: '蓝莓视频', path: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                樱花视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              樱花视频联合西瓜视频免费、芒果视频、蓝莓视频等平台，打造高清免费影视大全，电影电视剧全集在线观看不缓冲，流畅高清画质尽享。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-sm text-background-300"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-sm text-background-300"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 樱花视频 yinghuavideo.com 版权所有 | 本站内容仅供学习交流使用
            </p>
            <div className="flex items-center gap-4">
              <Link
                to="/"
                className="text-xs text-background-500 hover:text-background-300 transition-colors"
              >
                隐私政策
              </Link>
              <Link
                to="/"
                className="text-xs text-background-500 hover:text-background-300 transition-colors"
              >
                服务条款
              </Link>
              <Link
                to="/"
                className="text-xs text-background-500 hover:text-background-300 transition-colors"
              >
                免责声明
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}